import { render, staticRenderFns } from "./QuotationInfo.vue?vue&type=template&id=fe86252e&scoped=true"
import script from "./QuotationInfo.vue?vue&type=script&lang=ts"
export * from "./QuotationInfo.vue?vue&type=script&lang=ts"
import style0 from "./QuotationInfo.vue?vue&type=style&index=0&id=fe86252e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe86252e",
  null
  
)

export default component.exports